import { ButtonProps } from '../buttons/Button';
import { IconButtonProps } from '../buttons/IconButton';
import { DropdownProps } from '../dropdown/options-dropdown/OptionsDropdown';

export type ActionProps = ButtonProps | IconButtonProps | DropdownProps;

export type HeaderActionProps = Array<ActionProps> | false | undefined;

export function getHeaderActionsMargin(headerActionsLength: number): string {
  if (headerActionsLength === 0) {
    return '';
  }

  // switch necessary for tailwind compiler
  switch (headerActionsLength) {
    case 2:
      return 'mr-[88px]';
    case 3:
      return 'mr-[132px]';
    case 4:
      return 'mr-[176px]';
    case 1:
    default:
      return 'mr-[44px]';
  }
}

export function getHeaderActionsPadding(headerActionsLength: number): string {
  if (headerActionsLength === 0) {
    return '';
  }

  // switch necessary for tailwind compiler
  switch (headerActionsLength) {
    case 2:
      return 'pr-[88px]';
    case 3:
      return 'pr-[132px]';
    case 4:
      return 'pr-[176px]';
    case 1:
    default:
      return 'pr-[44px]';
  }
}
